<template>
  <gj-modal
      notFooterPadding
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增否定关键词</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :targetingType="0"
        ></app-base-info>
        <app-neg-keyword-picker
            ref="picker"
            :form="form.keywordPickerForm"
            title="否定关键词"
            :matchTypeOption="AdNegKeywordEnum.SP.matchTypeOption"
        ></app-neg-keyword-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import AppBaseInfo from "../common/sb-base-info";
  import AppNegKeywordPicker from "../common/neg-keyword-picker";
  import { isMeaningfulMixin, isMeaninglessMixin, modalMixIn } from "@/minxins";
  import { AdCampaignEnum, AdGroupEnum, AdNegKeywordEnum } from "@/views/modules/ad/common/enum";
  import { createAdsSbNegativeKeywords } from "@/api/ad";

  export default {
    name: "app-add-sp-ad-neg-keyword",
    components: {AppNegKeywordPicker, AppBaseInfo},
    mixins: [modalMixIn, isMeaninglessMixin, isMeaningfulMixin],
    props: {
      marketId: {
        required: true
      },
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignId: null,
            groupId: null
          },
          keywordPickerForm: {
            items: [],
            matchType: AdNegKeywordEnum.SP.matchType.NEGATIVE_EXACT
          }
        },
        AdGroupEnum,
        AdNegKeywordEnum
      }
    },
    watch: {},
    methods: {
      confirm() {
        const formValid = !['base', 'picker'].some(e => !this.$refs[e].formValidate());
        if (formValid) {
          const params = {
            marketId: this.marketId,
            keywords: this.form.keywordPickerForm.items.map(e => ({
              keywordText: e.keyword,
              matchType: e.matchType,
              campaignId: this.form.baseInfoForm.campaignId,
              groupId: this.form.baseInfoForm.groupId
            }))
          };
          this.confirmLoading = true;
          createAdsSbNegativeKeywords(params)
            .then(() => {
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";
</style>


